var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "state-item",
      class: { "is-select": _vm.isSelect, "is-hand": _vm.hand },
    },
    [
      _c("img", {
        staticClass: "pic",
        attrs: {
          src: require("@/assets/industryChainNew/" +
            (_vm.data.pic || "company1") +
            ".png"),
        },
      }),
      _c("div", { staticClass: "ml-16" }, [
        _c("div", { staticClass: "name" }, [_vm._v(_vm._s(_vm.data.name))]),
        _c(
          "div",
          { staticClass: "number mt-4" },
          [
            _c("AnimateNumber", {
              attrs: {
                fontSize: "26px",
                fontWeight: "600",
                number: _vm.data.count,
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }